import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-wallet-id-modal',
  templateUrl: './wallet-id-modal.component.html',
  styleUrls: ['./wallet-id-modal.component.scss']
})
export class WalletIdModalComponent implements OnInit {

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }

}
